export { useWebFonts } from './useWebFonts.web';
